const DATE_TIME_PARTS = 5

function pad(value: number) {
  return String(value).padStart(2, '0')
}

export function formatShanghaiDateTime(value: unknown): string {
  if (Array.isArray(value) && value.length >= 3) {
    const year = Number(value[0])
    const month = Number(value[1])
    const day = Number(value[2])
    const hour = value.length >= DATE_TIME_PARTS ? Number(value[3]) : 0
    const minute = value.length >= DATE_TIME_PARTS ? Number(value[4]) : 0
    if ([year, month, day, hour, minute].every(Number.isFinite)) {
      return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}`
    }
  }
  if (value && typeof value === 'object') {
    const dateTime = value as Record<string, unknown>
    const year = Number(dateTime.year)
    const month = Number(dateTime.monthValue ?? dateTime.month)
    const day = Number(dateTime.dayOfMonth ?? dateTime.day)
    const hour = Number(dateTime.hour ?? 0)
    const minute = Number(dateTime.minute ?? 0)
    if ([year, month, day, hour, minute].every(Number.isFinite)) {
      return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}`
    }
  }
  if (typeof value === 'string') {
    const normalized = value.trim()
    if (!normalized) return '—'
    const localDateTime = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/)
    if (localDateTime) return `${localDateTime[1]}-${localDateTime[2]}-${localDateTime[3]} ${localDateTime[4]}:${localDateTime[5]}`
  }
  if (typeof value === 'number' || typeof value === 'string') {
    const numeric = typeof value === 'number' ? value : Number(value)
    const date = Number.isFinite(numeric)
      ? new Date(Math.abs(numeric) < 1_000_000_000_000 ? numeric * 1000 : numeric)
      : new Date(value)
    if (!Number.isNaN(date.getTime())) {
      const parts = new Intl.DateTimeFormat('zh-CN', {
        timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
      }).formatToParts(date).reduce<Record<string, string>>((result, part) => {
        result[part.type] = part.value
        return result
      }, {})
      return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`
    }
  }
  return '—'
}
